<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'password'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">Transaction Password</h1>
							<div>f you forget the transaction password, please contact customer service to retrieve the
								transaction password</div>
						</div>
						<div class="form-container" style="margin-top: 20px;">
							<!-- Basic Info Section -->
							<div class="form-section">
								<h3 class="section-title">Transaction Password</h3>
								<!-- Shop Phone -->
								<div class="form-item" v-if="showOriginal">
									<label class="form-label">Original Password</label>
									<input v-model="formStore.originalPassword" type="password" class="form-input"
										placeholder="Please enter the original password" />
								</div>
								<!-- Introduction -->
								<div class="form-item">
									<label class="form-label">Transaction Password</label>
									<input v-model="formStore.payPassword" type="password" class="form-input"
										placeholder="Please enter the transaction password" required />
								</div>
								<!-- Shop Address -->
								<div class="form-item">
									<label class="form-label required">Confirm Password</label>
									<input v-model="formStore.confirmPassword" type="password" class="form-input"
										placeholder="Please enter the confirm password" required />
								</div>
								<!-- Save Button -->
								<div class="form-actions">
									<button type="button" class="btn-save" @click="handlePassword">Save</button>
								</div>
							</div>

						</div>


					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		passwordUpdate,
		storeDetail
	} from '../../api/home.js'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				formStore: {
					// originalPassword: '',
					payPassword: '',
					confirmPassword: ''
				},
				tableLoading: false,
				showOriginal: false,
			}
		},
		created() {
			this.getStoreDetail();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getStoreDetail() {
				storeDetail().then(res => {
					if (res.code == 200) {
						if (res.data.payPassword != "" && res.data.payPassword != null) {
							this.showOriginal = true
						}
					}
				})
			},
			handlePassword() {
				if (this.showOriginal) {
					if (!this.formStore.originalPassword) {
						this.$message.error('Please enter the original password')
						return
					}
				}
				if (!this.formStore.payPassword) {
					this.$message.error('Please enter the transaction password')
					return
				}
				if (this.formStore.payPassword != this.formStore.confirmPassword) {
					this.$message.error('Passwords do not match')
					return
				}
				passwordUpdate(this.formStore).then(res => {
					if (res.code == 200) {
						this.$message.success('Success')
						this.getStoreDetail();
						this.formStore.originalPassword = null
						this.formStore.payPassword = null
						this.formStore.confirmPassword = null
					} else {
						this.$message.error(res.msg)
					}
				})


			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
</style>
<style scoped>
	.form-container {
		max-width: 100%;
		padding: 20px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.form-section {
		margin-bottom: 20px;
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-bottom: 15px;
	}

	.form-item {
		margin-bottom: 15px;
	}

	.form-label {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #555;
		margin-bottom: 8px;
	}

	.required::after {
		content: " *";
		color: red;
	}

	.form-input,
	.form-textarea {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
	}

	.form-textarea {
		resize: vertical;
	}

	.logo-upload-container {
		position: relative;
		width: 100px;
		height: 100px;
		border: 2px dashed #007bff;
		border-radius: 4px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.upload-placeholder {
		width: 100%;
		height: 100%;
		background-color: #f8f9fa;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #007bff;
		cursor: pointer;
	}

	.uploaded-logo {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	.form-actions {
		text-align: right;
		margin-top: 20px;
	}

	.btn-save {
		background-color: #007bff;
		color: white;
		padding: 10px 20px;
		border: none;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
	}

	.btn-save:hover {
		background-color: #0056b3;
	}

	/* 移动端适配 */
	@media (max-width: 768px) {
		.form-container {
			padding: 15px;
		}

		.form-item {
			margin-bottom: 12px;
		}

		.logo-upload-container {
			width: 80px;
			height: 80px;
		}

		.form-input,
		.form-textarea {
			font-size: 13px;
		}

		.btn-save {
			padding: 8px 16px;
			font-size: 13px;
		}
	}
</style>
